import React from 'react';
import { Button } from '../ButtonElement';
import { Container, TopLine, ButtonContainer } from './TermsElements';
import { useNavigate } from 'react-router-dom';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <TopLine>Impressum</TopLine>

      <h3>Verantwortlich für den Inhalt dieser Seiten:</h3>
      <p>Information gemäß §5 E-Commerce-Gesetz und Offenlegung gemäß § 25 Mediengesetz</p>

      <h4>Diensteanbieter und Medieninhaber:</h4>
      <p>Ralph-Peter Zillbauer</p>
      <p>Strasshoferstraße 25/1/1<br />2620 Wartmannstetten</p>
      <p>Telefon: +43 660 165 0720</p>
      <p>Web: <a href="https://softwaresolution.at" target="_blank" rel="noopener noreferrer">softwaresolution.at</a></p>
      <p>E-Mail: <a href="mailto:info@softwaresolution.at">info@softwaresolution.at</a></p>

      <ButtonContainer>
        <Button onClick={() => navigate('/')}>Zurück zur Startseite</Button>
      </ButtonContainer>
    </Container>
  );
};

export default Terms;
